// extracted by mini-css-extract-plugin
module.exports = {"sales-report-container":"sales-report-container___1GlZ5"};